import React, { useContext } from "react";
import ProductSort from "../product-sort/product-sort";
import { SearchContext } from "../../contexts/typesense/SearchContext";
import InfiniteHits from "./infinite-hits";
import isEqual from 'react-fast-compare';

function getStateWithoutPage(state) {
  const { page, ...rest } = state || {};
  return rest;
}

function getInMemoryCache() {
  let cachedHits = undefined;
  let cachedState = undefined;
  return {
    read({ state }) {
      return isEqual(cachedState, getStateWithoutPage(state))
        ? cachedHits
        : null;
    },
    write({ state, hits }) {
      cachedState = getStateWithoutPage(state);
      cachedHits = hits;
    },
    clear() {
      cachedHits = undefined;
      cachedState = undefined;
    }
  };
}

const cache = getInMemoryCache();


export default function ProductList({ artist, eventType, handleButtonClick, customClasses }: { artist?: string, eventType?: string, customClasses?: string, handleButtonClick?: (k: string) => void }) {
  return (
    <div className={`col-md-12 p-0 p-md-4 pt-md-0 ${customClasses ?? ""}`}>
      {/* <ProductSort /> */}
      <InfiniteHits artist={artist} cache={cache} eventType={eventType} handleButtonClick={(k: string) => {
        handleButtonClick(k); console.log({ k });
      }} />
    </div>
  );
}
